import styled from 'styled-components';
// template components
import ExperienceCallout from '@nmx/template/dist/componentLibrary/modules/ExperienceCallout';

// eslint-disable-next-line import/prefer-default-export
export const ExperienceCalloutStyled = styled(ExperienceCallout)`
  .nmx-container {
    background-color: transparent; /* fixes bundling css bug, seems to be isolated to this instance */
  }
`;

